// -----------------  FETCH PRODUCT GALLERY -----------------
export const FETCH_PRODUCT_GALLERY_LOADING = 'FETCH_PRODUCT_GALLERY_LOADING';
export const FETCH_PRODUCT_GALLERY_SUCCESS = 'FETCH_PRODUCT_GALLERY_SUCCESS';
export const FETCH_PRODUCT_GALLERY_ERROR = 'FETCH_PRODUCT_GALLERY_ERROR';

// -----------------  CLEAR PRODUCT GALLERY -----------------
export const CLEAR_PRODUCT_GALLERY = 'CLEAR_PRODUCT_GALLERY';
